import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@hortis/ui/hover-card";
import { Tag } from "@hortis/ui/tag";
import { ObservationConditionType } from "generated/graphql";
import { useState } from "react";
import { stopEventPropagation } from "src/features/collection/components/stop-event-propagation";
import { ObservationConditionRating } from "src/features/material-page/sections/material-record-observations/observation-condition";
import { ObservationContent } from "src/features/material-page/sections/material-record-observations/observation-content";
import { getObservationDocument } from "src/features/records/material/graphql";
import { useGqlQuery } from "src/utils/hooks/graphql";
import { observationConditionLabelMap } from "src/utils/label-maps/observation-condition";
import { twMerge } from "tailwind-merge";

export const ObservationCell = ({
  value,
  daysOverdue,
}: {
  value: { condition: ObservationConditionType; id: string } | undefined | null;
  daysOverdue?: number | null | undefined;
}) => {
  const [open, setOpen] = useState(false);
  const { data } = useGqlQuery({
    query: getObservationDocument,
    variables: { id: value?.id ?? "" },
    enabled: value != null && open,
  });
  return (
    <>
      {value != null ? (
        <HoverCard open={open} onOpenChange={setOpen}>
          <HoverCardTrigger>
            <Tag
              className={twMerge(
                "transition",
                daysOverdue != null && daysOverdue > 0
                  ? "border-dashed grayscale text-grey-500"
                  : undefined,
                value.condition === ObservationConditionType.Good &&
                  "hover:bg-primary-25 hover:border-primary-300/70",
                value.condition === ObservationConditionType.Fair &&
                  "hover:bg-warning-25 hover:border-warning-300/70",
                value.condition === ObservationConditionType.Poor &&
                  "hover:bg-orange-25 hover:border-orange-300/70",
                value.condition === ObservationConditionType.Dead &&
                  "hover:bg-grey-50",
              )}
            >
              <ObservationConditionRating condition={value.condition} />
              {observationConditionLabelMap[value.condition]}
            </Tag>
          </HoverCardTrigger>
          {data?.observation != null && (
            <HoverCardContent
              className="max-w-md p-6"
              onClick={stopEventPropagation}
            >
              <ObservationContent observation={data?.observation} hideActions />
            </HoverCardContent>
          )}
        </HoverCard>
      ) : (
        "-"
      )}
    </>
  );
};
